<template>
  <div class="area-package">
    <!-- <app-header @on-click="goBack" :title="$t('packages.package_list')" /> -->
    <div class="package-contianer">
      <div class="package-head">
        <van-tabs :class="localPackageList.length === 1 ? 'van-tabs-con' : '' " v-show="localPackageList && localPackageList.length && isShowTagList" :active="activeTab" @change="packageTabsChange" swipe-threshold="3"  swipeable animated color="#4361EE" title-active-color="#4361ee" title-inactive-color="#000" line-width="6%" line-height="0.2em">
          <van-tab v-for="tab in localPackageList" :key="tab.tagKey" :title="tab.tagValueName" :name="tab.tagKey"></van-tab>
          <!-- <van-tab name="country2" :title="'区域服务'"></van-tab>
          <van-tab name="country3" :title="'全球服务'"></van-tab> -->
        </van-tabs>
      </div>
      <div class="package-content">
        <div class="package-tag-item" v-for="(group,index1) in packageList" :key="group.tagValueName">
          <template v-if="group.packageList && group.packageList.length">
            <h2 class="package-tag-title">{{group.tagValueName}}</h2>
            <div class="package-list" :class="group.className">
                <div class="package-item" @click="handlerSelectPackage(item)" :class="selectPackage && selectPackage.goodsId === item.goodsId ? 'active' : ''" v-for="(item,index2) in group.packageList" :key="item.goodsId">
                <span class="use_coupon_tips" v-show="item.deductionInfo && item.deductionInfo.autoRenewFirstPrice">{{ $t('packages.first_month')}}</span>
                <span class="use_coupon_tips" v-show="item.promotionCode">{{ $t('packages.special_offer') }}</span>
                <!-- <img v-if="selectPackage && selectPackage.goodsId === item.goodsId" class="selected-icon" src="@/assets/imgs/packages/select_package.png" alt="" /> -->
                <img v-if="selectPackage && selectPackage.goodsId === item.goodsId" class="selected-icon" :src="group.selectImg" alt="" />
                <div class="package-item-bg">
                    <h3 class="package-flow-rate" :class="item.isUnLimit ? 'package-flow-unlimit' : ''">
                        <span v-if="item.isUnLimit">
                            {{item.showFlow}}
                        </span>
                        <span v-else>
                            {{item.flowNum}}<span class="package-flow-unit">{{item.flowUnit}}</span>
                        </span>
                        <span v-show="item.showPkgMonthly" class="package-monthly">/{{item.showPkgMonthly}}</span>
                    </h3>
                    <div class="package-item-bpricebox">
                        <div class="package-price" :ref="`priceRef${index1 + '' + index2}`">
                            <span v-show="$i18n.locale !=='ar-AE' || !isCurrencySymbol(item.currencyType)">{{item.priceCurrencyType}}</span>
                            <span class="package-price-int">{{item.goodsIntPrice}}</span>
                            <span>{{item.pricePunctuation}}</span>
                            <span>{{item.goodsDecimalPrice}}</span>
                            <span v-show="$i18n.locale ==='ar-AE' && isCurrencySymbol(item.currencyType)">{{item.priceCurrencyType}}</span>
                            <span class="package-priceUnit" v-show="item.isShowPriceUnit && item.isShowPeriodBottom">{{item.periodBottom}}
                            </span>
                        </div>
                        <div class="package-first-list-price" v-show="item.isShowPeriodBottom && !item.isShowPriceUnit && item.categoryCode === 'LXCX' && item.payAgreeFlag == '1'">
                            <span>{{item.periodBottom}}</span>
                        </div>
                        <div class="package-list-price" v-show="!(item.isShowPeriodBottom && !item.isShowPriceUnit && item.categoryCode === 'LXCX' && item.payAgreeFlag == '1')">
                            <span v-show="item.promotionCode">{{item.originalPrice}}</span>
                        </div>
                        <!-- <div class="package-first-list-price" v-show="item.isShowPeriodBottom && (item.categoryCode !== 'LXCX' || item.payAgreeFlag != '1')">
                            <span>{{item.periodBottom}}</span>
                        </div> -->
                    </div>
                </div>
                <div class="package-item-validity">
                    <span v-show="item.isShowPeriod">{{item.showPeriod}}</span>   
                </div>
                </div>
            </div>
          </template>
        </div>
      </div>
      <div class="package-footer">
        <van-button class="gobuy-btn" :disabled="isDisabledBtn" @click="gotoDetail()" block type="info">{{ $t('Buy_Now') }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { keepTwodecimalFixed, isAndroid } from '../../utils/util'
import normal_bg from '../../assets/imgs/normal@3x.png'
import unlimited_bg from '../../assets/imgs/unlimited@3x.png'
import { Tab, Tabs } from 'vant';
import { deepClone } from "@/utils/util";
import cookie from '@/utils/cookie';
import checkProjectConfig from '@/lib/checkProjectConfig';
import selectImg1 from '@/assets/imgs/packages/select_01.png';
import selectImg2 from '@/assets/imgs/packages/select_02.png';
import selectImg3 from '@/assets/imgs/packages/select_03.png';
import selectImg4 from '@/assets/imgs/packages/select_04.png';
export default {
    name: 'NewPackageList',
    components: {
        vanTabs: Tabs,
        vanTab: Tab,
    },
    props: {
        allTagList: {
            type: Array,
            default: () => []
        },
        allPackageList: {
            type: Array,
            default: () => []
        },
        regionList: {
            type: Array,
            default: () => []
        },
        tagList: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            activeTab:'LOCAL',
            // regionList:[], // 区域列表
            localPackageList:[], 
            packageGroupList:[],
            selectPackage: null,
            roamingPackageList: [], // 全球漫游套餐列表
            isShowTagList:false,
        }
    },
    computed: {
        isDisabledBtn() {
            return this.selectPackage ? false : true;
        },
        packageList() {
            // if(this.activeTab === 'ROAMING'){
            //     return this.roamingPackageList || [];
            // }
            return this.localPackageList.find(item => item.tagKey === this.activeTab)?.packageGroupList || [];
        },
    },
    watch:{
        allPackageList: {
            handler(newVal) {
                if(newVal && newVal.length){
                    this.setup();
                    this.localPackageList = [];
                    this.handlerAllPackageList();
                }
            },
            immediate:true,
        }
    },
    mounted() {
        // this.setup();
    },
    methods: {
        async setup() {
            let placeCode = JSON.parse( sessionStorage.getItem('urlData') || '{}').placeCode  ||
                            JSON.parse( sessionStorage.getItem('ProjectConfigDetailData') || '{}').placeCode;
            if(placeCode) {
                this.placeCode = placeCode;
            }
            // let Module_Coupon = checkProjectConfig.setAppThat(this).checkValue("Module_Coupon",false);
            // if(Module_Coupon) {
            //     try {
            //         await this.getCouponsList();
            //     } catch (error) {
            //         console.log(error);
            //     }
            // }
            // await this.getHotRegion();
            // this.getPackageTagList();
        },
        goBack() {
            this.$router.go(-1);
        },  
        // 获取优惠券列表
        async getCouponsList() {
                let sessionStorageUrlData = JSON.parse(sessionStorage.urlData || '{}') || {};
                let res  = await this.$http
                .post({
                    url: "/bss/app/promotion/queryPromotionInst",
                    data: {
                        currentPage: 1,
                        perPageCount: 1000,
                        loginCustomerId: sessionStorageUrlData.loginCustomerId,
                        status:'AVAILABLE'
                    },
                })
                let data_CouponList = (res?.data?.dataList || []).map(item => {
                    return {
                        goodsList: item.goodsList,
                        promotionMode: item.promotionMode,
                        promotionCode: item.promotionCode,
                        fullCut: item.fullCut,
                        quota: item.quota,
                    }
                })
                sessionStorage.setItem('data-couponList', JSON.stringify(data_CouponList));
        },
        packageTabsChange(name) {
            this.activeTab = name; // 设置当前激活的标签
            this.selectPackage = null; // 切换标签时清除已选择的套餐
            this.handlerPriceUnit();
            // if(name === 'ROAMING' && (!this.roamingPackageList || !this.roamingPackageList.length)){
            //     this.getRoamingPackageList();
            // }
        },
        // 设置单个tab靠左
        setOneTabLeft() {
            setTimeout(() => {
                const elementA = document.querySelector('.package-head .van-tab');
                const elementB = document.querySelector('.package-head .van-tab__text');
                const elementC = document.querySelector('.package-head .van-tabs__line');
                let left = elementA.offsetLeft + elementB.offsetLeft + (elementB.offsetWidth / 2) - (elementC.offsetWidth / 2);
                elementC.style.transform = `translateX(${left}px)`;
            },0)
        },
        // 选择套餐
        handlerSelectPackage(item) {
            this.selectPackage = item;
        },
        // 跳转到详情页，去购买
        gotoDetail() {
            this.$router.push(this.$setRouteQuery({
                name: 'PackageDetail',
                query: {
                    goodsCode: this.selectPackage.goodsCode,
                    categoryCode: this.selectPackage.categoryCode,
                    goodsType: this.selectPackage.goodsType,
                    souce:this.$route.query.souce || '套餐列表',
                    promotionCode: this.selectPackage.promotionCode || '',
                }
            },this));
        },
        // 金额单位换行处理
        handlerPriceUnit() {
            if(!this.packageList || !this.packageList.length) return;
            this.$nextTick(() => {
                this.packageList.forEach((packageTag,index1) => {
                    packageTag.packageList.forEach((item,index2) => {
                        // 将this.$refs[`priceRef${index}`]下所有的子元素宽度加起来
                        if(item.categoryCode !== 'LXCX' || item.payAgreeFlag != '1'){
                            item.isShowPriceUnit = false;
                            return;
                        }
                        if(item.isOver) return; // 已经计算过的就不再计算
                        let totalWidth = 0;
                        let priceRef = this.$refs[`priceRef${index1 + '' + index2}`][0] || this.$refs[`priceRef${index1 + '' + index2}`] || null;

                        if(!priceRef) return;
                        let children = priceRef?.children || [];
                        for(let i = 0; i < children.length; i++) {
                            totalWidth += children[i].offsetWidth;
                        }
        
                        if( totalWidth >= priceRef.offsetWidth - 35 ){
                            item.isShowPriceUnit = false;
                        } else {
                            item.isShowPriceUnit = true;
                        }
                        item.isOver = true;
                    })
                })
            })
            
            return '';
        },
        // 获取视口高度 和 当前高度
        handlerPageHeight() {
            let viewportHeight =  window.innerHeight || 0;
            let current = document.querySelector('.area-package');
            let head = document.querySelector('.maya-app-header');
            let content = document.querySelector('.package-contianer');
            // 若 当前高度大于视口高度，则设置最小高度为视口高度
            if((current?.offsetHeight || 0) > viewportHeight){
                current.style.minHeight = viewportHeight + 'px';
                content.style.height = (viewportHeight - (head?.offsetHeight || 0)) + 'px';
            }
        },
        // 查询套餐标签 -- 旧版
        getPackageTagList() {
            let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
            if(!urlData.loginCustomerId) return;
            this.$http.post({
                url: 'bss/app/noauth/QueryOfferTag',
                data: {
                    ignoreOfferTagFlag: 1,
                    offerTagFlag:0,
                    offerTagMethod:1,
                }
            })
            .then((res) => {
                this.packageGroupList = [];
                let tagList = [];
                this.isShowPackageList = false;
                this.count = 0; // 重置计数器
                if(res.data && res.data.length){
                    res.data.forEach(element => {
                        // 目前先只查询本地流量套餐
                        let tagValueList = element.tagValueList || [];
                        if(element.tagKey === 'LOCAL') {
                            // 根据返回的标签调用接口查询本地流量套餐
                            if(!tagValueList || !tagValueList.length) {
                                // this.getLocalPackageList(); // 如果没有标签数据，则直接查询本地流量套餐
                            }
                            this.localPackageList.push({
                                tagValueName: urlData.registerCountryName || element.tagName,
                                tagKey: element.tagKey,
                                packageGroupList: [],
                            })
                            tagValueList.forEach(tag => {
                                tagList.push(tag.tagValueName);
                                this.getLocalPackageList(tag.extendValueMap || {}, tag.tagValueName);
                            });
                        } else if(element.tagKey === 'ROAMING') {
                            this.localPackageList.push({
                                tagValueName: element.tagName,
                                tagKey: element.tagKey,
                                packageGroupList: [],
                            })
                        }
                    })
                    this.allTagList = res.data;
                    this.activeTab = res.data[0].tagKey;
                } else {
                    // this.getLocalPackageList(); // 如果没有标签数据，则直接查询本地流量套餐
                }
                if(res.data && res.data.length === 1 && res.data[0].tagKey === 'ROAMING'){
                    this.getRoamingPackageList();
                }
                this.packageTagList = tagList;
                this.localPackageList.forEach(item => {
                    if(item.tagKey === 'LOCAL') { 
                        item.packageGroupList = tagList.map(tag => ({
                            tagValueName: tag,
                            packageList: []
                        }));
                    }
                });
                this.packageGroupList = tagList.map(tag => ({
                    tagValueName: tag,
                    packageList: []
                }));
            })
            .catch((err) => {
                console.log(err);
            });
        },
        // 查询热门大洲套餐 -- 旧版
        async getHotRegion() {
            let typeCode ;
            let typeCode_mvnoCode = JSON.parse(sessionStorage.getItem('urlData') || '{}').mvnoCode;

            if(typeCode_mvnoCode){
                typeCode =  `HOTREGION_${typeCode_mvnoCode.toUpperCase()}`;
                this.$http.post({
                    url: '/bss/app/noauth/dictionary/QueryDictionaryValueListInfo',
                    data: {                      
                        type: typeCode, 
                    }
                }).then(res => {
                    // Africa - UN60 、Oceania - UN29、 Asia - UN50、European - UN52、SouthAmerica - UN57、 NorthAmerica - UN57
                    this.regionList = res.data || [];
                }).catch(() => {
                });
            }
        },
        // 全球漫游服务 -- 旧版
        getRoamingPackageList() {
            let urlData = JSON.parse(sessionStorage.urlData) || {};
            let channelType = this.$APP_CONFIG.request.channelType;
            let extendAttrs = this.regionList.map(item => item.key);
            this.$http.post({
                url: '/bss/app/noauth/QueryOfferList',
                data: {                        
                    channelType,
                    queryLimitFlag: true,
                    queryPromotionFlag: true,
                    sortFlag: 1,
                    showFlowFlag:1,
                    areaFlag: 'ROAMING', // 全球漫游
                    params: {
                        queryVipDayFlag: true
                    },
                    buyTerminalType:urlData.terminalType,
                    goodsExtendAttrs:["detailRemark","hideFlowSize",...extendAttrs] // detailRemark 获取扩展属性
                }
            }).then(res => {
                let tmpList = res.data.dataList || [];
                tmpList = tmpList.length > 0 ? this.initLocalPackageData(tmpList) : [];

                // 按套餐标签进行分类
                tmpList = tmpList.map(item => ({...item, attrValueList: [] }));  
                tmpList.forEach(item => {
                    if(item.extendValVos && item.extendValVos.length){
                        item.extendValVos.forEach(val => {
                            item.attrValueList = [...item.attrValueList, ...val.attrValueList];
                        });
                    }
                });
                this.roamingPackageList = []
                this.regionList.forEach(region => {
                    tmpList.forEach(item => {
                        let attr = item.extendValVos?.find(val => val.attrCode === region.key) || {};
                        if(item.extendValVos && item.extendValVos.length && attr?.attrCode) {
                            if(this.roamingPackageList.some(val => val.tagKey === attr?.attrCode)) {
                                let index = this.roamingPackageList.findIndex(val => val.tagKey === attr?.attrCode);
                                this.roamingPackageList[index].packageList.push(item);
                            } else {
                                this.roamingPackageList.push({
                                    tagValueName: region.value,
                                    tagKey: attr?.attrCode,
                                    packageList: [item]
                                })
                            }
                        } 
                    })
                })
                if(!this.roamingPackageList.length){
                    this.localPackageList = this.localPackageList.filter(item => {
                        return item.tagKey !== "ROAMING";
                    });
                }

                if(this.localPackageList.length === 1){
                    this.setOneTabLeft();
                }
                this.isShowTagList = true;
                this.$nextTick(() => {
                    this.handlerPriceUnit();
                    this.handlerPageHeight();
                })
            }).catch(err => {
                this.$toast(err);
                console.log(err);
                
            });
        },
        // 本地流量 -- 旧版
        getLocalPackageList(extendValueMap,tagValueName) {
            let urlData = JSON.parse(sessionStorage.urlData) || {};
            let channelType = this.$APP_CONFIG.request.channelType,
                mcc = this.placeCode;
            let extendAttrs = this.regionList.map(item => item.key);
            this.$http.post({
                url: '/bss/app/noauth/QueryOfferList',
                data: {                        
                    channelType,
                    mcc,
                    queryLimitFlag: true,
                    queryPromotionFlag: true,
                    sortFlag: 1,
                    showFlowFlag:1,
                    areaFlag: 'LOCAL', // 保留原来没有extendValueMap的逻辑，查询本地流量套餐
                    params: {
                        queryVipDayFlag: true
                    },
                    buyTerminalType:urlData.terminalType,
                    extendValueMap, // 根据扩展属性查询对应的标签套餐
                    goodsExtendAttrs:["detailRemark","hideFlowSize",...extendAttrs] // detailRemark 获取扩展属性
                }
            }).then(res => {
                let tmpList = res.data.dataList || [];
                tmpList = tmpList.length > 0 ? this.initLocalPackageData(tmpList) : [];

                // 按套餐标签进行分类
                tmpList = tmpList.map(item => ({...item, attrValueList: [] }));  
                tmpList.forEach(item => {
                    if(item.extendValVos && item.extendValVos.length){
                        item.extendValVos.forEach(val => {
                            item.attrValueList = [...item.attrValueList, ...val.attrValueList];
                        });
                    }
                });
                
                let localPackageList = tmpList.filter(item => {
                    return !item.multiRegionFlag;
                })
                

                localPackageList = localPackageList.filter(item => {
                    // 过滤出当前mcc套餐
                    if(item.iso2List && item.iso2List.length && mcc) {
                        return item.iso2List.includes(mcc);
                    }
                })
                
                let regionPackageList = tmpList.filter(item => {
                    return item.multiRegionFlag;
                })
                
                this.count += 1; // 增加计数器
                // 本地服务流量数据结构处理
                this.handlerLocalPackages(localPackageList, tagValueName);

                regionPackageList.forEach(item => {
                    let attr = item.extendValVos?.find(val => extendAttrs.includes(val.attrCode)) || {};
                    if(item.extendValVos && item.extendValVos.length && attr?.attrCode) {
                        if(this.localPackageList.some(val => val.tagKey === attr?.attrCode)) {
                        } else {
                            let tab = this.regionList.find(region => region.key === attr?.attrCode) || {};
                            let pObj = {
                                tagValueName: tab.value,
                                tagKey: attr?.attrCode,
                                packageGroupList: deepClone(this.packageGroupList),
                            }
                            let length = this.localPackageList.length;
                            if(length > 1){
                                this.localPackageList.splice(length - 1, 0, pObj)
                            } else {
                                this.localPackageList.push(pObj)
                            }
                        }
                    } else {
                        if(!this.localPackageList.some(val => val.tagKey === 'AREA')){
                            let pObj = {
                                tagValueName: this.$t('packages.regional_data'),
                                tagKey: 'AREA',
                                packageGroupList: deepClone(this.packageGroupList),
                            }
                            let length = this.localPackageList.length;
                            if(length > 1){
                                this.localPackageList.splice(length - 1, 0, pObj);
                            } else {
                                this.localPackageList.push(pObj);
                            }
                        }
                    }
                })
                // 区域服务流量数据结构处理
                regionPackageList && this.handlerAreaPackages(regionPackageList, tagValueName);
                
                if(this.count >= this.packageTagList.length && this.packageTagList?.length){ // 如果所有标签查询完成
                    this.count = 0; // 重置计数器
                    this.localPackageList = this.localPackageList.filter(item => {
                        return (item.packageGroupList && item.packageGroupList.length) || item.tagKey === "ROAMING";
                    });
                    this.activeTab = this.localPackageList[0]?.tagKey || 'LOCAL';
                    // 如果包含全球服务就直接调
                    if(this.localPackageList.some(item => {
                        return item.tagKey === 'ROAMING';
                    })) {
                        this.getRoamingPackageList();
                    } else {
                        this.isShowTagList = true;
                        setTimeout(() => {
                            this.handlerPriceUnit();
                            this.handlerPageHeight();
                        }, 300);
                    }

                    if(this.localPackageList.length === 1){
                        this.setOneTabLeft();
                    }
                }
            }).catch(err => {
                this.$toast(err);
                console.log(err);
                
            });
        },
        // 处理本地服务流量 -- 旧版
        handlerLocalPackages(list,tagValueName) {
                this.localPackageList.forEach(item => {
                    if(item.tagKey === 'LOCAL') {
                        if(this.packageTagList && this.packageTagList.length){
                            let index = item.packageGroupList.findIndex(packageGroup => packageGroup.tagValueName === tagValueName);
                            if(list && list.length) {
        
                                item.packageGroupList.splice(index, 1, {
                                    tagValueName: tagValueName,
                                    packageList: list
                                });
                            } else {
                                let index = item.packageGroupList.findIndex(packageGroup => packageGroup.tagValueName === tagValueName);
                                item.packageGroupList.splice(index, 1);
                            }    
                        }
                    }
                });
        },
        // 处理区域服务流量 -- 旧版
        handlerAreaPackages(list,tagValueName){
            let extendAttrs = this.regionList.map(item => item.key);
            this.localPackageList.forEach(item => {
                let arr = list.filter(packageItem => {
                    if(item.tagKey === 'AREA'){
                        return !packageItem.extendValVos || !packageItem.extendValVos?.some(attr => extendAttrs.includes(attr.attrCode))
                    }
                    return packageItem.extendValVos?.some(attr => attr.attrCode === item.tagKey);
                });

                if(this.packageTagList && this.packageTagList.length && item.tagKey !== 'LOCAL') {  
                    let index = item.packageGroupList.findIndex(packageGroup => packageGroup.tagValueName === tagValueName);
                    if(arr && arr.length) {
                        item.packageGroupList.splice(index, 1, {
                            tagValueName: tagValueName,
                            packageList: arr
                        });
                    } else {
                        let index = item.packageGroupList.findIndex(packageGroup => packageGroup.tagValueName === tagValueName);
                        item.packageGroupList.splice(index, 1);
                    }
                }
            })
        },
        // 处理套餐数据
        handlerAllPackageList(){
            let urlData = JSON.parse(sessionStorage.urlData) || {};
            let channelType = this.$APP_CONFIG.request.channelType,
            mcc = this.placeCode;
            let extendAttrs = this.regionList.map(item => item.key);
            let tmpList = deepClone(this.allPackageList) || [];
            tmpList = tmpList.length > 0 ? this.initLocalPackageData(tmpList) : [];
            if(!tmpList || !tmpList.length) return;
            // 按套餐标签进行分类
            tmpList = tmpList.map(item => ({...item, attrValueList: [] }));  
            tmpList.forEach(item => {
                if(item.extendValVos && item.extendValVos.length){
                    item.extendValVos.forEach(val => {
                        item.attrValueList = [...item.attrValueList, ...val.attrValueList];
                    });
                    item.attrCodeList = item.extendValVos.map((val) => val.attrCode);
                }
            });

            let RoamingPackageList = tmpList.filter(item => {
                return item?.attrMap?.areaFlag === 'ROAMING' || item?.attrMap?.areaFlag === 'ALL';
            })

            // let localPackageList = tmpList.filter(item => {
            //     return (item?.attrMap?.areaFlag === 'LOCAL' || item?.attrMap?.areaFlag === 'ALL') && !item.multiRegionFlag && item.iso2List.includes(mcc);
            // });

            let regionPackageList = tmpList.filter(item => {
                return (item?.attrMap?.areaFlag === 'LOCAL' || item?.attrMap?.areaFlag === 'ALL') && (item.iso2List.includes(mcc) || item.iso2List.includes('ALL'));
            });

            let localPackageList = regionPackageList.filter(item => {
                let attr = item.extendValVos?.find(val => extendAttrs.includes(val.attrCode)) || {};

                return !attr?.attrCode
            });
            // 本地流量
            let list = this.handlerTagSort(localPackageList, this.tagList);
            let localObj = this.allTagList.find(item => item.tagKey === 'LOCAL'); 
            (localObj && list && list.length) ? this.localPackageList = [{
                tagValueName: sessionStorage.getItem('registerCountryName') || localObj.tagName,
                tagKey: localObj.tagKey,
                packageGroupList: list,
            }] : '';

            // 区域流量 - 有区域标签
            this.regionList.forEach(region => {
                let list = regionPackageList.filter(item => {
                    return item.extendValVos?.some(val => val.attrCode === region.key);
                });
                let areaList = this.handlerTagSort(list || [], this.tagList)
                if(!list || !list.length || !areaList || !areaList.length) return;
                let pObj = {
                    tagValueName: region.value,
                    tagKey: region.key,
                    packageGroupList: areaList,
                }
                this.localPackageList.push(pObj);
                
            })

            // // 区域流量 - 无区域标签
            // let nonTabRegion = regionPackageList.filter(item => {
            //     let attr = item.extendValVos?.find(val => extendAttrs.includes(val.attrCode)) || {};

            //     return !attr?.attrCode
            // });
            
            // if(nonTabRegion && nonTabRegion.length){
            //     let areaList = this.handlerTagSort(nonTabRegion || [], this.tagList)
            //     let pObj = {
            //         tagValueName: this.$t('packages.regional_data'),
            //         tagKey: 'AREA',
            //         packageGroupList: areaList,
            //     }
            //     if(areaList && areaList.length) this.localPackageList.push(pObj);
            // }

          // 全球漫游服务 - 有就查询
            if(this.allTagList.some(item => item.tagKey === 'ROAMING' )){
                let roamingObj = this.allTagList.find(item => item.tagKey === 'ROAMING' );
                if(RoamingPackageList && RoamingPackageList.length) {
                    let list = this.handlerTagSort(RoamingPackageList || [], this.regionList);
                    if(list && list.length){
                        let pObj = {
                            tagValueName: roamingObj.tagName,
                            tagKey: roamingObj.tagKey,
                            packageGroupList: list,
                        }
            
                        this.localPackageList.push(pObj);
                    }
                }

                this.activeTab = this.localPackageList[0]?.tagKey || 'LOCAL';

                if(this.localPackageList.length === 1){
                    this.setOneTabLeft();
                }
                this.isShowTagList = true;
                this.$nextTick(() => {
                    this.handlerPriceUnit();
                    this.handlerPageHeight();
                })
            } else {
                this.localPackageList = this.localPackageList.filter(item => {
                return item.packageGroupList && item.packageGroupList.length;
                });
                this.activeTab = this.localPackageList[0]?.tagKey || 'LOCAL';
                
                this.isShowTagList = true;

                setTimeout(() => {
                    this.handlerPriceUnit();
                    this.handlerPageHeight();
                }, 300);

                if(this.localPackageList.length === 1){
                    this.setOneTabLeft();
                }
            }
        },
        // 标签分类
        handlerTagSort(list = [],tagList) {
            // 按标签进行套餐分类
            let groupList = [];
            if (tagList && tagList.length) {
                tagList.forEach((tag,index) => {
                    let packageList = list.filter((item) => {
                        return item.attrCodeList && item.attrCodeList.includes(tag.key);
                    });
                    if(packageList && packageList.length) {
                        let num = (index + 1) % 4 === 0 ? 4 : (index + 1) % 4
                        let className = `package-list-${num}`;
                        let selectImg = ``;
                        switch (num) {
                            case 1:
                                selectImg = selectImg1;
                                break;
                            case 2:
                                selectImg = selectImg2;
                                break;
                            case 3:
                                selectImg = selectImg3;
                                break;
                            case 4:
                                selectImg = selectImg4;
                                break;
                        }
                        groupList.push({
                            tagValueName: tag.value,
                            packageList,
                            className,
                            selectImg
                        });
                    }
                });
            } else {
                // list && list.length
                //     ? (groupList = [
                //         {
                //         packageList: list || [],
                //         },
                //     ])
                //     : (groupList = []);
                (groupList = []);
            }
            
            return groupList
        },
        initLocalPackageData(list) {                
            let newList = [];

            for(let i = 0;i < list.length;i++) {                    
                let item  = list[i];
                item.goodsPrice = +item.goodsPrice + "";

                // 页面只显示DISC、PKAG
                if(item.goodsType != 'DISC' && item.goodsType != 'PKAG') {
                    continue;
                }
                // 过滤黑名单
                if(item.mccFlag && item.mccFlag == 'BLACK') {
                    continue;
                }
                // 过滤掉用户自定义
                if(item.attrMap.effType == 'USER_DEFINED') {
                    continue;
                }
                // 过滤掉DIY
                if((item.goodsType == 'DISC' && item.categoryCode == 'GDIY') || (item.goodsType == 'PKAG' && item.attrMap.pkType == 'DIY')) {
                    continue;
                }
                // 过滤掉CZME
                if(item.categoryCode && item.categoryCode == 'CZME') {
                    continue;
                }
                // 过滤DSDS
                /*
                if(item.terminalType == 'DSDS') {
                    continue;
                }
                */
                
                item.item_bg = unlimited_bg;
                if(item.goodsType == 'DISC') {
                    item.item_bg = unlimited_bg;
                } else if(item.goodsType == 'PKAG') {
                    item.item_bg = normal_bg;
                }
                
                // 处理价格
                item.listPriceShow = false;
                item.vipPriceShow = false;
                if(item.payAgreeFlag == "1" && item.deductionInfo != null && item.deductionInfo.autoRenewActCode != null) {
                    // vip会员日并且最低价是discountPrice
                    if(item.vipAct && item.vipAct === '1' && this.minPriceIsDiscountPrice(item)) {
                        this.doPriceStyle(item, item.goodsPrice, 'goodsPriceText');
                        this.doPriceStyle(item, item.discountPrice, 'vipPrice');
                        item.vipPriceShow = true;
                    } else {
                        let autoRenewFirstPrice = item.deductionInfo.autoRenewFirstPrice ? item.deductionInfo.autoRenewFirstPrice : 0.0;
                        if(autoRenewFirstPrice > 0 && autoRenewFirstPrice < item.goodsPrice) {
                            this.doPriceStyle(item, this.getMinPrice(item), 'goodsPriceText');
                            item.listPriceShow = true;
                            this.doPriceStyle(item, item.goodsPrice, 'listPrice');
                        } else {
                            this.doPriceStyle(item, this.getMinPrice(item), 'goodsPriceText');
                        }
                    }
                } else {
                    // vip 会员日
                    if(item.vipAct && item.vipAct === '1') {
                        this.doPriceStyle(item, item.goodsPrice, 'goodsPriceText');
                        this.doPriceStyle(item, item.discountPrice, 'vipPrice');
                        item.vipPriceShow = true;
                    } else {
                        this.doPriceStyle(item, item.discountPrice !== null ? item.discountPrice : item.goodsPrice, 'goodsPriceText');
                        if(item.discountPrice != null) {
                            this.doPriceStyle(item, item.goodsPrice, 'listPrice');
                            item.listPriceShow = true;
                        }
                    }
                }

                // 原价
                this.doPriceStyle(item, item.goodsPrice, 'originalPrice');

                // // 自动连续包月的续购价格
                // if(item.deductionInfo && item.deductionInfo.autoRenewPrice){
                //     this.doPriceStyle(item, item.deductionInfo.autoRenewPrice, 'goodsPriceText');
                // }

                this.e_preCalcOrder(item);

                // 格式化价格，拆分为整数和小数
                if(item.goodsPriceText) {
                    let lowerCurrency = item.currencyType.toLowerCase();
                    let codeType = this.$APP_CONFIG.currencyTypeMap[lowerCurrency] ? this.$APP_CONFIG.currencyTypeMap[lowerCurrency] : item.currencyType;
                    item.priceCurrencyType = codeType;
                    let price = item.goodsPriceText.split(item.currencyType)[1];
                    if(!price && this.$APP_CONFIG.currencyTypeMap[item.currencyType.toLowerCase()]){
                        price = item.goodsPriceText.split(this.$APP_CONFIG.currencyTypeMap[item.currencyType.toLowerCase()])[1];
                    }
                    let priceParts = price.split('.');
                    // 保存一下数据
                    item.goodsPriceNum = price && price.replace(',','.');
                    if(priceParts.length >= 2){
                        item.goodsIntPrice = priceParts[0].trim();
                        item.goodsDecimalPrice = +priceParts[1] === 0 ? '' : this.formatStringNumber(priceParts[1]);
                        item.pricePunctuation =  item.goodsDecimalPrice ? '.' : '';
                    } else {
                        item.goodsIntPrice = price.split(',')[0].trim();
                        item.goodsDecimalPrice = +price.split(',')[1]  === 0 ? '' :  this.formatStringNumber(price.split(',')[1]);
                        item.pricePunctuation = item.goodsDecimalPrice ? ',' : '';
                    }
                }
                //生成角标
                this.genSaleIcon(item);

                // 流量大小
                item.showFlow = this.doFlowByteText(item);
                item.showPeriod = this.getValidityPeriod(item);
                item.isShowPriceUnit = true;

                item.isShowPeriod = true;

                let [flowNum,flowUnit] = this.splitSize(item.showFlow);

                item.flowNum = flowNum;
                item.flowUnit = flowUnit;


                // // 如果是年包则分别展示
                // if(item.goodsType === 'PKAG' && ((item.period >= 180 && item.periodUnit === 'DAY') || (item.period >= 6 && item.periodUnit === 'MONTH'))) {
                //     item.isShowPeriod = false;
                //     item.isShowPeriodBottom = true;
                //     item.periodBottom = ' ' + this.getValidityPeriod(item);
                // }
                // 高速流量包
                if(item.goodsType === 'DISC' && item.billingInfos && (item.period > 1 && item.periodUnit === 'MONTH')) {
                    item.isShowPeriod = true;
                    item.isShowPriceUnit = false;
                    item.isShowPeriodBottom = true;
                    // item.showPeriod = ' ' + this.handlerBillingInfo(item);
                    // if(item.billingInfos[0]?.period > 1) item.showPeriod = ' ' + item.billingInfos[0]?.period + this.handlerBillingInfo(item);
                    item.showPkgMonthly = this.$t('packages.periodUnit.month');
                    item.periodBottom = this.getUnitOfPrice(item.goodsPriceNum, item.period) + '/' + this.getUnitOfTime(item.periodUnit,1);
                }
                
                // 连续畅想套餐，展示底部月单位
                if(item.categoryCode === 'LXCX' && item.payAgreeFlag == '1'){
                    // item.isShowPeriod = false;
                    item.showPeriod = this.$t('select_package.auto_subscribe');
                    item.isShowPeriodBottom = true;
                    if(item.period) item.periodBottom = '/' + this.getUnitOfTime(item.periodUnit, item.period);
                }
                
                // 获取隐藏流量大小扩展属性值，用于展示无限流量，2 - 无限流量
                if(item.extendValVos && item.extendValVos.length){
                    let isUnLimit = item.extendValVos.some(extend => {
                        if(extend.attrCode === 'hideFlowSize' && extend.attrValueList.includes('2')) {
                            return true;
                        }
                    })
                    if(isUnLimit) {
                        item.showFlow = this.$t('packages.unLimitData');
                        item.isUnLimit = true;
                        item.showPkgMonthly = '';
                    }
                }
                
                // multi region packages
                if(item.iso2List && (item.iso2List.length > 1 || item.iso2List[0] == 'ALL')) {                 
                    item.multiRegionFlag = true;
                } else if (item.goodsType == 'DISC') {
                    if (['BYTC', 'SWBY', 'BTTC', 'LXCX'].includes(item.categoryCode)) {
                        item.unlimitedFlag = true;
                        this.doUnlimitedPackages(item);
                    }
                } else if(item.goodsType == 'PKAG') {
                    if(item.attrMap.pkType != 'DIY') {
                        item.normalFlag = true;
                        this.doNormalPackages(item)
                    }
                }

                newList.push(item);
            }
            
            return newList;
        },
        // 计算优惠券后的价格
        e_preCalcOrder(item) {
            if(['LXCX'].includes(item.categoryCode) && item.payAgreeFlag == '1') return;
            let couponList = JSON.parse(sessionStorage.getItem('data-couponList') || "[]");
            let promotionCode = '';
            let cutPrice = couponList.reduce((prev, curr) => {
                let cutPrice = 0;
                if(curr.goodsList.includes('ALL') || curr.goodsList.includes(item.goodsId)){
                    if(['P01','P03'].includes(curr.promotionMode)){
                        cutPrice = (+item.goodsPrice) * (curr.quota / 100);
                    } else {
                        cutPrice = curr.quota * 100;
                    }

                    if(['P01','P02'].includes(curr.promotionMode) && +item.goodsPrice < +curr.fullCut * 100){
                        cutPrice = 0
                    }
                }

                if(prev > cutPrice) {
                    return prev;
                } else {
                    promotionCode = curr.promotionCode;
                    return cutPrice;
                }
            }, 0);

            let finalPrice = +item.goodsPrice - cutPrice;
            if(finalPrice >= 0 && finalPrice < this.getMinPrice(item)) {
                this.doPriceStyle(item, finalPrice, 'goodsPriceText');
                item.promotionCode = promotionCode;
            } else if(finalPrice < 0) {
                this.doPriceStyle(item, 0, 'goodsPriceText');
                item.promotionCode = promotionCode;
            }
        },
        // 处理流量大小问题
        splitSize(str) {
            const match = str.match(/^(-?\d+(?:\.\d+)?)([a-zA-Z]+)$/);
            return match ? [parseFloat(match[1]), match[2]] : [null, null];
        },
        // 处理年套餐每月金额问题
        getUnitOfPrice(price, num){
            if(!price) return '';
            let priceNum = price.replace(/,/g, ''); // 去掉价格中的逗号

            const result = priceNum / +num;
            const rounded = Math.round(result * 10) / 10; // 四舍五入到一位小数
            
            // 检查是否是整数（考虑浮点数精度）
            if (Math.abs(rounded - Math.round(rounded)) < 0.0001) {
                return Math.round(rounded).toString();
            }
            return rounded.toString();
        },
        // 处理小数位问题
        formatStringNumber(str) {
            // 如果字符串以'0'开头，直接返回原字符串
            if (str.startsWith('0')) {
                return str;
            }
            
            // 将字符串转换为数字，然后去除末尾的零
            let num = parseInt(str, 10);
            
            // 不断除以10直到不能整除
            while (num > 0 && num % 10 === 0) {
                num = Math.floor(num / 10);
            }
            
            return num.toString();
        },
        // 处理高速流量单位
        handlerBillingInfo(item) {
            let text = '';
            if(item.billingInfos && item.billingInfos.length) {
                let billingInfo = item.billingInfos[0];
                if(billingInfo.periodUnit == 0) {
                    if(billingInfo.period > 1){
                        text = this.$t('packages.periodUnits.hour');
                    } else {
                        text = this.$t('packages.periodUnit.hour');
                    }
                } else if(billingInfo.periodUnit == 1) {
                    if(billingInfo.period > 1){
                        text = this.$t('packages.periodUnits.day');
                    } else {
                        text = this.$t('packages.periodUnit.day');
                    }
                } else if(billingInfo.periodUnit == 2 || billingInfo.periodUnit == 12) {
                    if(billingInfo.period > 1){
                        text = this.$t('packages.periodUnits.month');
                    } else {
                        text = this.$t('packages.periodUnitMonthly');
                    }
                } else if(billingInfo.periodUnit == 3) {
                    if(billingInfo.period > 1){
                        text = this.$t('packages.periodUnits.year');
                    } else {
                        text = this.$t('packages.periodUnit.year');
                    }
                }
            }
            return text;
        },
        // 处理流量大小显示
        doFlowByteText(item) {
            let flowText = '0MB',
                flowValue = item.billingInfos && item.billingInfos.length ? item.billingInfos[0].flow : (item.flowByte ? item.flowByte : 0);                    

            if(flowValue >= 1000) {
                let flow = flowValue/1024;
                // 判断是不是整数
                if(Math.floor(flow) === flow) {
                    flowText = `${flow}GB`;
                } else {
                    let langType = cookie.getCookie('langType')
                    // 部分欧洲国家小数点采取 ， 形式
                    let country = ['es-ES','pt-PT','de-DE','fr-FR']; 
                    let showFlow = keepTwodecimalFixed(flow)
                    if(country.includes(langType)){
                        showFlow = showFlow.replace('.',',')
                    }
                    flowText = `${showFlow}GB`;
                }
            } else {
                flowText = `${flowValue}MB`;
            }

            return flowText;        
        },
        //连续包月增加--20241205--start
        getValidityPeriod (a) {
            // 有效期
            let periodTxt = '';

            if (a.attrMap.expType && (a.attrMap.expType == 'CURRENT_MONTH' || a.attrMap.expType == 'CURRENT_DAY')) {
                periodTxt = this.getTypeOfFailures(a);      // 失效类型
            } else {
                if (a.period == null || a.period == '') {
                    periodTxt = '';
                } else {
                    let actionType = this.getEffectiveType (a);     // 生效类型
                    periodTxt = a.period +' '+ this.getUnitOfTime (a.periodUnit, a.period) + ' ' + actionType;
                }
            }
            return periodTxt;
        },
        getTypeOfFailures (a) {
            // 失效类型
            let actionType = '';

            if (a != null && a != '' && a.attrMap.expType) {
                if (a.attrMap.expType == 'CURRENT_MONTH') {
                    actionType = this.$t('packages.month_invalid');
                } else if (a.attrMap.expType == 'CURRENT_DAY') {
                    actionType = this.$t('packages.day_invalid');
                } else if (a.attrMap.expType == 'DEFAULT') {
                    actionType = '';
                } else {
                    actionType = '';
                }
            }
            return  actionType;
        },
        getEffectiveType (a) {
            // 生效类型
            let actionType = '';

            if (a != null && a != '' && a.attrMap.effType) {
                if (a.attrMap.effType == 'IMMEDIATELY') {
                    a.period == null || a.period == '' ? actionType = this.$t('packages.immediate_valid') : actionType = ''

                } else if (a.attrMap.effType == 'MORROW') {
                    a.period == null || a.period == '' ? actionType = this.$t('packages.tomorrow_day_valid') : actionType = '';

                } else if (a.attrMap.effType == 'USER_DEFINED') {
                    actionType = '';

                } else if (a.attrMap.effType == 'NEXT_MONTH') {
                    a.period == null || a.period == '' ? actionType = this.$t('packages.tomorrow_month_valid') : actionType = '';

                } else {
                    actionType = '';
                }
            }
            return actionType;
        },
        getUnitOfTime (a, b) {
            let unit = a;

            if (unit == 'DAY' || unit == null || unit == '') {
                if (parseInt(b) < 2 || b == null || b =='') {
                    unit = this.$t('packages.periodUnit.day');
                } else {
                    unit = this.$t('packages.periodUnits.day');
                }
            } else if (unit == 'MONTH') {
                if (parseInt(b) < 2 || b == null || b =='') {
                    unit = this.$t('packages.periodUnit.month');
                } else {
                    unit = this.$t('packages.periodUnits.month');
                }
            }
            return unit;
        },
        genSaleIcon(item) {
            /*
                * sale icon
                * */
            item.saleTextShow = false;
            item.saleIconShow = false;
            let _w = 'auto';
            if(isAndroid()) {
                /*
                if(Math.floor(window.devicePixelRatio) == 1) {
                    _w = `${100/3}%`
                } else if(Math.floor(window.devicePixelRatio) == 2 || Math.floor(window.devicePixelRatio) == 3) {
                    _w = `${(100*2)/3}%`;
                }
                */
            } else {
                if(Math.floor(window.devicePixelRatio) == 1) {
                    _w = `${100/3}%`
                } else if(Math.floor(window.devicePixelRatio) == 2) {
                    _w = `${(100*2)/3}%`;
                }
            }
            item.saleIconStyle = {
                width: _w
            };
            let saleImageUrl = '';
            // 获取图标
            if(item.cornerMark != null && Object.values(item.cornerMark).length > 0 && Object.values(item.cornerMark).some(val => val != '')) {
                if(item.payAgreeFlag == "1" && item.deductionInfo != null && item.deductionInfo.autoRenewActCode != null) {
                    saleImageUrl = item.cornerMark[item.deductionInfo.autoRenewActCode];
                } else {
                    saleImageUrl = item.cornerMark[item.promotionActivityCode];
                }
            } else if(item.iconInfos && item.iconInfos.length > 0) {
                saleImageUrl = item.iconInfos[0].attrValue;
            }
            // 判断图标是否为空
            if(saleImageUrl) {
                item.saleImageUrl = saleImageUrl;
                item.saleIconShow = true;
            }
            let img = new Image(),iconStyle = {};
            img.addEventListener('load', () => {
                if(img.width >= this.boxItemWidth) {
                    iconStyle = {width: '100%'};
                } else {
                    iconStyle = {width: 'auto'};
                }
                this.$set(item,'iconStyle',iconStyle);
            },false)

            if(item.saleImageUrl){
                img.src = item.saleImageUrl;    
            }
            
        },
        doNormalPackages(item) {
            this.genName(item);
            this.doNormalPackagesCycle(item);
        },
        //处理普通包有效期
        doNormalPackagesCycle(item) {
            let expireToday = item.goodsType != 'DISC' && item.attrMap.expType == 'CURRENT_DAY',
                expireThisMonth = item.goodsType != 'DISC' && item.attrMap.expType == 'CURRENT_MONTH',
                effectiveImmediately = item.goodsType == 'DISC' && item.attrMap.effType == 'IMMEDIATELY',
                effectiveMarrow = item.goodsType == 'DISC' && item.attrMap.effType == 'MARROW',
                effectiveNextMonth = item.goodsType == 'DISC' && item.attrMap.effType == 'NEXT_MONTH';

            if(expireToday || expireThisMonth) {
                item.period = expireToday ? `${this.$t('packages.day_invalid')}` : `${this.$t('packages.month_invalid')}`
            } else {
                if(item.period) {
                    let singleUnit = this.$t(`packages.periodUnit.${item.periodUnit.toLowerCase()}`),
                        multipleUnit = this.$t(`packages.periodUnits.${item.periodUnit.toLowerCase()}`);
                    item.period = item.period > 1 ? `${item.period} ${multipleUnit}` : `${item.period} ${singleUnit}`;
                    if(effectiveImmediately) {
                        item.period = item.period > 1 ? `${item.period} ${multipleUnit}(${this.$t('packages.immediate_valid')})` : `${item.period} ${singleUnit}(${this.$t('packages.immediate_valid')})`;
                    } else if(effectiveMarrow) {
                        item.period = item.period > 1 ? `${item.period} ${multipleUnit}(${this.$t('packages.tomorrow_day_valid')})` : `${item.period} ${singleUnit}(${this.$t('packages.tomorrow_day_valid')})`;
                    } else if(effectiveNextMonth) {
                        item.period = item.period > 1 ? `${item.period} ${multipleUnit}(${this.$t('packages.tomorrow_month_valid')})` : `${item.period} ${singleUnit}(${this.$t('packages.tomorrow_month_valid')})`;
                    }
                }
            }
        },
        doUnlimitedPackages(item) {
            this.genName(item);
            // 0为按小时取，1为按天取，2为按月取，3为按年取，12为动态月也是按月取同2
            item.high_speed_text = this.$t('packages.high_speed_text');
            let billInfo = item.billingInfos;
            if(billInfo && billInfo.length > 0) {
                if(billInfo[0].periodUnit === 0) {
                    if(item.period == billInfo[0].period && item.periodUnit == 'HOUR') {
                        item.high_speed_text = this.$t('packages.high_speed_text');
                    } else {
                        if(billInfo[0].period > 1) {
                            item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.hour')
                        } else {
                            item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.hour')
                        }
                    }

                } else if(billInfo[0].periodUnit === 1) {
                    if(item.period == billInfo[0].period && item.periodUnit == 'DAY') {
                        item.high_speed_text = this.$t('packages.high_speed_text');
                    } else {
                        if(billInfo[0].period > 1) {
                            item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitSimp.day')
                        } else {
                            item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.day')
                        }
                    }

                } else if(billInfo[0].periodUnit === 2 || billInfo[0].periodUnit === 12) {
                    if(item.period == billInfo[0].period && item.periodUnit == 'MONTH') {
                        item.high_speed_text = this.$t('packages.high_speed_text');
                    } else {
                        if(billInfo[0].period > 1) {
                            item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.month')
                        } else {
                            item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.month')
                        }
                    }
                } else if(billInfo[0].periodUnit === 3) {
                    if(item.period == billInfo[0].period && item.periodUnit == 'YEAR') {
                        item.high_speed_text = this.$t('packages.high_speed_text');
                    } else {
                        if(billInfo[0].period > 1) {
                            item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.year')
                        } else {
                            item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.year')
                        }
                    }
                }
            }

            if(item.categoryCode == 'BTTC' || (item.categoryCode == 'LXCX' && item.periodUnit == 'DAY')) {
                item.goodsNameStr = this.$t('packages.unlimited_good_name.day');

            } else if (item.categoryCode == 'BYTC' || item.categoryCode == 'SWBY' || (item.categoryCode == 'LXCX' && item.periodUnit == 'MONTH')) {
                if(item.period && item.period == 12) {
                    item.goodsNameStr = this.$t('packages.unlimited_good_name.year');
                } else {
                    if(item.attrmap && item.attrmap.period && item.attrmap.period == 12) {
                        item.goodsNameStr = this.$t('packages.unlimited_good_name.year');
                    } else {
                        item.goodsNameStr = this.$t('packages.unlimited_good_name.month');
                    }
                }
            }
        },
        genName(item) {
            let flow = (item.billingInfos && item.billingInfos.length > 0) ? item.billingInfos[0].flow : item.flowByte;
            if(flow > 0) {
                if(flow > 1000) {
                    flow = flow/1024;
                    // 判断是不是整数
                    if(Math.floor(flow) === flow) {
                        item.goodsName_H5_tag = `${flow}GB`;
                    } else {
                        item.goodsName_H5_tag = `${keepTwodecimalFixed(flow)}GB`;
                    }
                } else {
                    item.goodsName_H5_tag = `${flow}MB`;
                }
            } else {
                item.goodsName_H5_tag = `0MB`;
            }
        },
        getMinPrice(item) {
            let prices = [];

            if(item.deductionInfo?.autoRenewFirstPrice) {
                prices.push(item.deductionInfo.autoRenewFirstPrice);
            }
            if(item.deductionInfo?.autoRenewPrice) {
                prices.push(item.deductionInfo.autoRenewPrice);
            }
            if(item.discountPrice) {
                prices.push(item.discountPrice);
            }
            if(item.goodsPrice) {
                prices.push(item.goodsPrice);
            }

            return Math.min(...prices);
        },
        doPriceStyle(item, price, key) {
            //price = keepTwodecimalFull(price/100);
            //item[key] = `${item.currencyType} ${price}`;
            item[key] = this.globalPriceFormat(item.currencyType, price);                
        },
        minPriceIsDiscountPrice(item) {
            let autoRenewFirstPrice = item.deductionInfo.autoRenewFirstPrice ? item.deductionInfo.autoRenewFirstPrice : 0.0;
            let autoRenewPrice = item.deductionInfo.autoRenewPrice ? item.deductionInfo.autoRenewPrice : 0.0;
            let discountPrice = item.discountPrice ? item.discountPrice : 0.0;
            if(autoRenewPrice > discountPrice && autoRenewFirstPrice > discountPrice) {
                return true;
            }
            return false;
        },
        // 判断是否使用了货币符号
        isCurrencySymbol(price='') {
            let typeList = [];
            if(this.$APP_CONFIG.currencyTypeMap) {
                typeList = Object.keys(this.$APP_CONFIG.currencyTypeMap);
            }
            return typeList.some(item => {
                return price?.toLowerCase()?.includes(item) && this.$APP_CONFIG.currencyTypeMap[item];
            })
        },
    }
};
</script>

<style lang="less" scoped>
.ml2 {
    margin-left: 2px;
}
.area-package {
  background-color: #f2f2f2;
//   min-height: 100vh;
//   min-height: 100dvh;
  min-height: 100%;
    ::v-deep {
        .header {
            font-weight: 600;
            .title {
                font-size: 15px;
            }
        }
    }
  .package-contianer {
    height: calc(100vh - 44px);
    height: calc(100dvh - 44px);
    // height: calc(100% - 48px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .package-head {
      width: 100%;
      height: 50px;
      background-color: #fff;
      ::v-deep {
        .van-tabs-con {
            .van-tabs__nav {
                justify-content: start;
                padding-left: 10px;
                .van-tab {
                    justify-content: start;
                }
                .van-tabs__line {
                    // transform: translateX(10px) !important;
                }
            }
        }
      }
    }
    .package-content {
      height: 100%;
      overflow-y: auto;
      padding: 0 12px 12px;
      .package-tag-item {
        margin-top: 14px;
        .package-tag-title {
          font-size: 14px;
        }
        .package-list {
          width: 100%;
          margin-top: 6px;
          // display: flex;
          // gap: 10px;
          // flex-wrap: wrap;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 10px 10px;
          .package-item {
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            // min-height: 110px;
            background-color: #fff;
            border-radius: 12px;
            flex-shrink: 0;
            width: 100%;
            text-align: center;
            border: 2px solid transparent;
            .package-item-bg {
                background-color: #fff;
                border-radius: 10px;
                min-height: 80px;
                padding: 20px 0 2px;
                flex: 1;
            }
            .use_coupon_tips {
                position: absolute;
                color: #fff;
                background-color: #ff4e4e;
                font-size: 10px;
                top: -2px;
                left: -2px;
                padding: 0px 5px;
                min-width: 28px;
                border-radius: 12px 0;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                // &::before {
                //     content: '';
                //     border-style: solid;
                //     position: absolute;
                //     top: 0;
                //     border-width: 8px 11px 8px 0;
                //     border-color: transparent #fff transparent transparent;
                //     right: -1px;
                // }
            }
            .selected-icon {
              position: absolute;
              right: -1px;
              top: -1px;
              width: 18px;
              height: 18px;
            }
            .package-flow-rate {
              font-size: 16px;
              font-weight: 600;
              word-break: break-all;
              color: #666;
              margin-bottom: 24px;
            }
            .package-flow-unit {
                font-size: 11px;
            }
            .package-flow-unlimit {
                font-size: 15px;
                letter-spacing: -1px;
            }
            .package-monthly {
                font-size: 10px;
                color: rgba(0, 0, 0, 0.5);
                font-weight: normal;
            }
            .package-item-validity {
              font-size: 11px;
              font-variation-settings: "opsz" auto;
              font-feature-settings: "kern" on;
              color: rgba(0, 0, 0, 0.5);
              min-height: 30px;
            //   line-height: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
              word-break: break-all;
              font-weight: 600;
            }
            // .package-item-bpricebox {
            //     position: relative;
            //     width: 100%;
            //     bottom: 20px;
            // }
            .package-price {
            //   margin-top: 12px;
              font-family: Source Han Sans;
              font-variation-settings: "opsz" auto;
              font-feature-settings: "kern" on;
              color: #ff4e4e;
              font-size: 10px;
              word-break: break-all;
              padding-left: 1px;
              padding-right: 1px;
              .package-price-int {
                font-size: 16px;
                font-weight: 700;
                margin-left: 2px;
              }
              .package-priceUnit {
                color: rgba(0, 0, 0, 0.5);
              }
            }
            .package-list-price {
              height: 12px;
              line-height: 12px;
            //   margin-top: 4px;
              font-size: 10px;
              text-decoration: line-through;
              font-variation-settings: "opsz" auto;
              font-feature-settings: "kern" on;
              color: rgba(0, 0, 0, 0.5);
            }
            .package-first-list-price {
              height: 12px;
              line-height: 12px;
            //   margin-top: 4px;
              font-size: 10px;
              padding-left: 5px;
              padding-right: 5px;
              font-variation-settings: "opsz" auto;
              font-feature-settings: "kern" on;
              color: rgba(0, 0, 0, 0.5);
              word-break: break-all;
            }
          }
          .package-item.active {
            border: 2px solid #4361ee;
          }
        }
        .package-list-1 {
            .package-item {
                background: #C6E6FA;
                .package-flow-rate {
                    color: #0074BC;
                }
                .package-item-validity {
                    color: #0074BC;
                }
                &.active {
                    border: 2px solid #0074BC;
                }
            }
        }
        .package-list-2 {
            .package-item {
                background: #C5EECF;
                .package-flow-rate {
                    color: #018321;
                }
                .package-item-validity {
                    color: #018321;
                }
                &.active {
                    border: 2px solid #018321;
                }
            }
        }
        .package-list-3 {
            .package-item {
                background: #EEDFC5;
                .package-flow-rate {
                    color: #BE7800;
                }
                .package-item-validity {
                    color: #BE7800;
                }
                &.active {
                    border: 2px solid #BE7800;
                }
            }
        }
        .package-list-4 {
            .package-item {
                background: #E6D9F9;
                .package-flow-rate {
                    color: #844BDE;
                }
                .package-item-validity {
                    color: #844BDE;
                }
                &.active {
                    border: 2px solid #844BDE;
                }
            }
        }
      }
    }
    .package-footer {
      width: 100%;
      background-color: #fff;
      padding: 12px;
      .gobuy-btn {
        background-color: #4361ee;
        border-radius: 8px;
        width: 100%;
        height: 40px;
      }
    }
  }
}
</style>